import { Box } from '@mui/material';
import React, { FC } from 'react';

import GridItem from '../../components/Grid/GridItem';
import Heading, { HeadingSize } from '../../components/Heading';
import Image from '../../components/Image';
import Markdown from '../../components/Markdown';
import { BadgeResource } from '../../models';

const PENDING_BADGE_OPACITY = 0.2;

const EarnedBadgeGrid: FC<{ item: BadgeResource }> = ({ item }) => {
  return (
    <GridItem
      maxColumns={6}
      size={1}
      style={{
        opacity: item.attributes.earned ? 1 : PENDING_BADGE_OPACITY,
        textAlign: 'center',
      }}
    >
      <Box component={Heading} size={HeadingSize.LG} sx={{ fontSize: { sm: '.9em', md: '1em' } }}>
        {item.attributes.title}
      </Box>
      <Image
        style={{
          height: 'auto',
          marginBottom: '1em',
          maxWidth: '100%',
          width: '180px',
        }}
        url={item.attributes.image}
      />
      <Markdown text={item.attributes.description} />
    </GridItem>
  );
};

export default EarnedBadgeGrid;
